<template>
    <div class="main">
        <!-- Title of page -->
        <div class="page-title-container">
            {{text['activities'].title}}
        </div>

        <!-- Links to sections -->
        <div class="main-link-container flex-wrap">
            <div class="main-link-element" v-for="(x, i) in Object.keys(text['activities'].mainLinks)" :key="i">
                <div class="main-link-title">
                    {{ x }}
                </div>
                <div class="main-link-image-container">
                    <div class="inbetween-img-container">
                        <img class="main-link-image" :class="[text['activities'].mainLinks[x].imageAlign]" :src="text['activities'].mainLinks[x].image">
                    </div>
                </div>
                <button class="main-link-btn" @click="scrollMeTo(text['activities'].mainLinks[x].link)">
                    {{ text['activities'].mainLinks[x].text }}
                </button>
            </div>
        </div>

        <!-- <hr class="line-separator" /> -->

        <!-- Ejercicio funcional -->
        <div class="section-container" id="functional-exercise-container">
            <div class="section-title-container">
                <div class="section-title-background">
                    <span class="section-title-title">
                        {{ text['activities'].functionalExerciceInfo.title }}
                    </span>
                </div>
                <div class="section-title-text" v-if="text['activities'].functionalExerciceInfo.description.length != 0">
                    <span class="section-title-description">
                        {{ text['activities'].functionalExerciceInfo.description }}
                    </span>
                </div>
            </div>
            <div class="section-info-container">
                <div class="section-info-element" v-for="(k, i) in Object.keys(text['activities'].functionalExerciceInfo.methodsOfTreatement)" :key="i">
                    <div class="section-info-title">
                        {{ k }}
                    </div>
                    <div class="section-info-element-text">
                        <div class="section-info-element-text-container" v-for="(lines, j) in text['activities'].functionalExerciceInfo.methodsOfTreatement[k]" :key="j">
                            {{ lines }}<br/>
                            <ul class="section-list-container" v-if="Object.keys(text['activities'].lists).includes(k+j)">
                                <li v-for="element in text['activities'].lists[k+j]" :key="element">
                                    {{ element }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="pictures-container" v-if="Object.keys(text['activities'].pictures).includes(k)">
                        <div class="picture-container" v-for="element in text['activities'].pictures[k]" :key="element">
                            <img :style="'top:' + element.topPosition +';'" :src="element.picture" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr class="line-separator extra-x-margin line-separator-small-screen" />

        <!-- Yoga info container -->
        <!-- <div class="section-container" id="yoga-container">
            <div class="section-title-container">
                <div class="section-title-background section-title-background-right">
                    <span class="section-title-title">
                        {{ text['activities'].yogaInfo.title }}
                    </span>
                </div>
                <div class="section-title-text section-title-text-right">
                    <span class="section-title-description section-title-description-right">
                        {{ text['activities'].yogaInfo.description }}
                    </span>
                </div>
            </div>
            <div class="section-info-container">
                <div class="section-info-element" v-for="(k, i) in Object.keys(text['activities'].yogaInfo.methodsOfTreatement)" :key="i">
                    <div class="section-info-title">
                        {{ k }}
                    </div>
                    <div class="section-info-element-text">
                        <div class="section-info-element-text-container" v-for="(lines, j) in text['activities'].yogaInfo.methodsOfTreatement[k]" :key="j">
                            {{ lines }}<br/>
                            <ul class="section-list-container" v-if="Object.keys(text['activities'].lists).includes(k+j)">
                                <li v-for="element in text['activities'].lists[k+j]" :key="element">
                                    {{ element }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="pictures-container" v-if="Object.keys(text['activities'].pictures).includes(k)">
                        <div class="picture-container" v-for="element in text['activities'].pictures[k]" :key="element">
                            <img :style="'top:' + element.topPosition +';'" :src="element.picture" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr class="line-separator extra-x-margin line-separator-small-screen" /> -->

        <!-- Musica en familia info container -->
        <div class="section-container" id="music-with-family-container">
            <div class="section-title-container">
                <div class="section-title-background section-title-background-right">
                    <span class="section-title-title">
                        {{ text['activities'].musicWithFamilyInfo.title }}
                    </span>
                </div>
                <div class="section-title-text section-title-text-right">
                    <span class="section-title-description">
                        {{ text['activities'].musicWithFamilyInfo.description }}
                    </span>
                </div>
            </div>
            <div class="section-info-container">
                <div class="section-info-element" v-for="(k, i) in Object.keys(text['activities'].musicWithFamilyInfo.methodsOfTreatement)" :key="i">
                    <div class="section-info-title">
                        {{ k }}
                    </div>
                    <div class="section-info-element-text">
                        <div class="section-info-element-text-container" v-for="(text, j) in text['activities'].musicWithFamilyInfo.methodsOfTreatement[k]" :key="j">
                            {{ text }}<br/>
                        </div>
                    </div>
                    <div class="pictures-container" v-if="Object.keys(text['activities'].pictures).includes(k)">
                        <div class="picture-container" v-for="element in text['activities'].pictures[k]" :key="element">
                            <img :style="'top:' + element.topPosition +';'" :src="element.picture" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-5"></div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
    name: "Activities",
    data() {
        return {}
    },
    computed: {
        ...mapGetters(["idSelected", "text"]),
    },
    methods: {
        ...mapMutations(["setIdSelected"]),
        scrollMeTo(refName) {
            let element = document.querySelector(refName);
            let top = element.offsetTop - 150;
            window.scrollTo(0, top);
        },
    },
    mounted() {
        if(this.idSelected.length > 0) {
            this.scrollMeTo(this.idSelected);
            this.setIdSelected("");
        } else {
            setTimeout(function () {
                window.scrollTo(0, 0);
            }, 1);
        }
    },
}
</script>

<style scoped>
.main {
    overflow: hidden;
}

.pictures-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 3rem;
    margin: 2rem 0;
}

.picture-container {
    width: 200px;
    height: 200px;
    border-radius: 50%;
    overflow: hidden;
    position: relative;
    box-shadow: 0 0 15px 0 var(--blue-color);
}

.picture-container > img {
    width: 100%;
    position: absolute;
}
</style>